import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorSecurityLock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M11.006 1.764a1.881 1.881 0 0 1 1.988 0 10.07 10.07 0 0 0 5.814 1.516c.986-.045 1.942.708 1.942 1.8v8.738c0 1.33-.523 2.554-1.26 3.613-.736 1.06-1.712 1.993-2.694 2.763a18.872 18.872 0 0 1-2.823 1.828c-.414.216-.79.39-1.102.51-.155.061-.302.112-.435.149a1.68 1.68 0 0 1-.436.069 1.68 1.68 0 0 1-.436-.07 4.609 4.609 0 0 1-.435-.148 11.343 11.343 0 0 1-1.102-.51 18.874 18.874 0 0 1-2.823-1.828c-.982-.77-1.958-1.703-2.695-2.763-.736-1.059-1.259-2.283-1.259-3.613V5.08c0-1.091.957-1.844 1.942-1.8a10.07 10.07 0 0 0 5.813-1.516ZM12.2 3.037a.382.382 0 0 0-.402 0 11.57 11.57 0 0 1-6.674 1.741.392.392 0 0 0-.277.096.27.27 0 0 0-.098.205v8.74c0 .928.366 1.857.99 2.756.625.898 1.482 1.727 2.39 2.438.904.71 1.837 1.284 2.593 1.68.377.197.703.345.95.442a3.133 3.133 0 0 0 .327.11l.036-.01c.07-.02.166-.052.29-.1a9.83 9.83 0 0 0 .951-.443 17.37 17.37 0 0 0 2.594-1.679c.907-.71 1.764-1.54 2.388-2.438.625-.899.991-1.828.991-2.757V5.08a.27.27 0 0 0-.098-.205.392.392 0 0 0-.277-.096A11.57 11.57 0 0 1 12.2 3.037Z"
    />
    <path
      fill="#F7A600"
      d="M14.725 10.1h.075c.966 0 1.75.783 1.75 1.75v3.201a1.75 1.75 0 0 1-1.75 1.75H9.5a1.75 1.75 0 0 1-1.75-1.75V11.85c0-.967.783-1.75 1.75-1.75h.075V9.025a2.575 2.575 0 1 1 5.15 0V10.1Zm-3.65 0h2.15V9.025a1.075 1.075 0 1 0-2.15 0V10.1ZM14.8 15.3a.25.25 0 0 0 .25-.25V11.85a.25.25 0 0 0-.25-.25H9.5a.25.25 0 0 0-.25.25v3.201c0 .138.112.25.25.25h5.3Z"
    />
  </svg>
);
export default SvgTwoColorSecurityLock;
